import React from "react";
import { AssetHeader } from "./Assets.styled";
import DashboardLayout from "../Layout/DashboardLayout";
import { Row } from "antd";
import InventoryChart from "../admin/components/dashboardCharts/InventoryChart";
import SalesChart from "../admin/components/dashboardCharts/SalesChart";
import CostChart from "../admin/components/dashboardCharts/CostChart";
import { connect } from "react-redux";

const DashboardManagement = (props) => {
  const { my_roles } = props;
  const privileges = my_roles[0]?.role?.privileges;
  return (
    <DashboardLayout pageTitle="Asset Dashboard">
      <AssetHeader data-aos="fade-right">
        <h3>Dashboard Management</h3>
      </AssetHeader>

      <div data-aos="fade-right">
        {privileges?.includes("inventory.get_inventory") && (
          <Row>
            <InventoryChart />
          </Row>
        )}
        {privileges?.includes("sales.get_sale") && (
          <Row>
            <SalesChart />
          </Row>
        )}
        {privileges?.includes("sales.get_sale") && (
          <Row>
            <CostChart />
          </Row>
        )}
      </div>
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    my_roles: state.userManagementReducer.my_roles,
  };
};

export default connect(mapStateToProps, {})(DashboardManagement);
